import { environment } from "src/environments/environment"

export function getValidateSomeCompany(businessPartners){
    let find = businessPartners.find(ele => ele.company.code == environment.companycode)
    return find
}